import React from 'react';

export default function CardBlock(): JSX.Element {
  return <div></div>
}